import { render, staticRenderFns } from "./BnAddressInput.vue?vue&type=template&id=0c39bb88&scoped=true&"
import script from "./BnAddressInput.vue?vue&type=script&lang=js&"
export * from "./BnAddressInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c39bb88",
  null
  
)

export default component.exports